module.exports = __webpack_public_path__ + "img/zixun.faeabb53.svg";